import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import apiService from '../../services/api';

// Async thunks
export const fetchMetalPrices = createAsyncThunk(
  'metalPrices/fetchMetalPrices',
  async (_, { rejectWithValue }) => {
    try {
      // console.log('fetchMetalPrices thunk called');
      const response = await apiService.getMetalPrices();
      // console.log('fetchMetalPrices thunk received response:', response.data);
      return response.data;
    } catch (error) {
      console.error('fetchMetalPrices thunk error:', error);
      return rejectWithValue(error.response?.data || 'Failed to fetch metal prices');
    }
  }
);

// Metal price slice
const metalPriceSlice = createSlice({
  name: 'metalPrices',
  initialState: {
    prices: {
      gold: null,
      silver: null,
      platinum: null
    },
    history: {
      gold: [],
      silver: [],
      platinum: []
    },
    loading: false,
    error: null,
    lastUpdated: null
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchMetalPrices.pending, (state) => {
        state.loading = true;
        state.error = null;
        // console.log('Metal prices loading state set to true');
      })
      .addCase(fetchMetalPrices.fulfilled, (state, action) => {
        state.loading = false;
        // console.log('Metal prices fulfilled with payload:', action.payload);

        // Update current prices (API now includes 'previous' field from database)
        state.prices = action.payload.current;

        // Add to history if provided
        if (action.payload.history) {
          state.history = action.payload.history;
        }

        state.lastUpdated = new Date().toISOString();
        // console.log('Metal prices state updated successfully');
      })
      .addCase(fetchMetalPrices.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        console.error('Metal prices fetch rejected with error:', action.payload);
      });
  },
});

export default metalPriceSlice.reducer;
